export default function Footer() {
  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#000000] border-t border-white/[0.06] py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/cebdc8d2-642a-4486-a7d1-116edfe42b48_Screenshot-2026-04-27-134053.png?v=e342e4f583d18517e22766607e8d913b"
              alt="AceAge-Music"
              className="h-24 w-auto object-contain mb-5"
            />
            <p className="text-white/40 text-sm leading-relaxed max-w-xs mb-6">
              We make a difference in the world of music. Founded by Andreas Schmidt — Music production, label services, and artist developement from Germany to the world.
            </p>
            {/* Social */}
            <div className="flex items-center gap-4">
              {[
                { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/AceAgeMusic/', label: 'Facebook' },
                { icon: 'ri-instagram-line', href: 'https://www.instagram.com/aceagemusic/', label: 'Instagram' },
                { icon: 'ri-soundcloud-line', href: 'https://soundcloud.com/ace-da-brain', label: 'SoundCloud' },
                { icon: 'ri-youtube-fill', href: 'https://www.youtube.com/channel/UCiFndkQkaGvLbDJBZBiFKTA', label: 'YouTube' },
              ].map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-full text-white/40 hover:text-white hover:border-white/30 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white/40 text-xs font-medium tracking-[0.3em] uppercase mb-5">Navigation</h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', href: '#hero' },
                { label: 'About Andreas', href: '#about' },
                { label: 'Services', href: '#services' },
                { label: 'Our Artists', href: '#artists' },
                { label: 'Releases', href: '#releases' },
                { label: 'Contact', href: '#contact' },
              ].map(link => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={e => { e.preventDefault(); scrollToSection(link.href); }}
                    className="text-white/50 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>


        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/[0.06] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs">
            © {new Date().getFullYear()} AceAge-Music. All rights reserved.
          </p>
          <p className="text-white/25 text-xs">
            Founded by <span className="text-white/40">Andreas Schmidt</span> · Germany
          </p>
        </div>
      </div>
    </footer>
  );
}
